import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

import { formatCurrency } from './pricingLevelPerformanceUtils'

export default function PricingLevelRevenueLeakage({ revenueLeakage }) {
  const levels = revenueLeakage?.levels || []
  const total = revenueLeakage?.totalUnsoldOpportunity || 0

  if (!levels.length) return null

  return (
    <Card
      body
      className="card--xs card-with-border pricing-level-revenue-leakage-card"
    >
      <h2 className="h5 mb-1">Revenue Opportunity / Leakage</h2>
      <p className="small text-muted mb-3">
        Unsold inventory value still available by pricing level.
      </p>

      <Table responsive className="pricing-level-revenue-leakage-table mb-0">
        <thead>
          <tr>
            <th>Pricing Level</th>
            <th className="text-end">Lost Revenue Opportunity</th>
          </tr>
        </thead>
        <tbody>
          {levels.map((row) => (
            <tr key={row.pricingLevelId}>
              <td className="pricing-level-name">{row.name}</td>
              <td className="text-end metric-value">
                {formatCurrency(row.lostRevenueOpportunity)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="pricing-level-revenue-leakage-total">
            <th scope="row">Total Unsold Opportunity</th>
            <td className="text-end">{formatCurrency(total)}</td>
          </tr>
        </tfoot>
      </Table>
    </Card>
  )
}
